import CryptoJS, { HmacSHA1 } from 'crypto-js';
import { randomUUID, ksort } from '../utils/utility';
import qs from 'qs';

const apiHost = process.env.NODE_ENV === 'development' ? 'http://localhost:8080/api' : '';

const Settings = {
  api_host :apiHost,
  
  app_key: '1842dec0-b8a1-efcd-710d-7aeb13ae8bdc',
  hmac_key: '1842dec0-b8a2-6477-5274-42299c93e118',
  dat_key: 'b8a2647752744229',
};

//https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURIComponent#examples
const RFC3986EncodeURIComponent = (str) => {
  return encodeURIComponent(str).replace(
    /[!'()*]/g,
    (c) => `%${c.charCodeAt(0).toString(16).toUpperCase()}`,
  );
  //encodeURIComponent not encode A-Z a-z 0-9 - _ . ! ~ * ' ( )
};

const buildSignature = (param) => {
  let params = ksort(param);
  //params may be a FormData object
  let queryString = Object.keys(params).map((key) => {
      return RFC3986EncodeURIComponent(key) + '=' + RFC3986EncodeURIComponent(params[key]);
    }).join('&');
  let hash = HmacSHA1(queryString, Settings.hmac_key);
  let b64 = CryptoJS.enc.Base64.stringify(hash);
  let signature = b64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');//.replace(/\+/g, '*').replace(/\//g, '-').replace(/=/g, '');
  
  //console.groupEnd();
  // console.log(signature);
  return signature;
};

const buildDataParams = (params = {}) => {
  try {
    Settings.ds = Settings.dat_key;
    const key = CryptoJS.enc.Utf8.parse(Settings.ds); // 确保 key 是合法 WordArray

    // 生成随机 IV（16字节）
    const iv = CryptoJS.lib.WordArray.random(16);

    // 加密参数配置
    const options = {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    };

    // 直接使用 JSON 字符串明文（CryptoJS 自动处理 UTF-8 转换）
    const encrypted = CryptoJS.AES.encrypt(JSON.stringify(params), key, options);

    // 拼接 IV 和密文（IV 在前）
    const combined = iv.concat(encrypted.ciphertext);

    // 转为 URL 安全的 Base64（删除末尾填充符 `=`）
    let b64 = CryptoJS.enc.Base64.stringify(combined);
    b64     = b64.replace(/\+/g, '-').replace(/\//g, '_');
    // 补充填充符至长度为 4 的倍数
    const padLength = (4 - (b64.length % 4)) % 4;
    return b64 + (padLength > 0 ? '='.repeat(padLength) : '');
  } catch (err) {
    throw new Error(`加密失败: ${err.message}`);
  }
};

const decryptDataParams = (encryptedData) => {
  try {
    Settings.ds = Settings.dat_key;
    const key   = CryptoJS.enc.Utf8.parse(Settings.ds);

    // Step 1: 转换 URL 安全 Base64 回标准格式
    let base64 = encryptedData
      .replace(/-/g, '+')
      .replace(/_/g, '/');
    // 补充填充符 `=`
    const pad = base64.length % 4;
    if (pad) base64 += '===='.slice(pad);

    // Step 2: 解析 Base64
    const combined = CryptoJS.enc.Base64.parse(base64);
    if (combined.sigBytes < 16) {
      throw new Error("密文长度不足以提取 IV");
    }

    // Step 3: 提取 IV（前16字节）和密文
    const iv = CryptoJS.lib.WordArray.create(combined.words.slice(0, 4));
    const ciphertext = CryptoJS.lib.WordArray.create(combined.words.slice(4));
    ciphertext.sigBytes = combined.sigBytes - 16; // 修正密文字节长度

    // Step 4: 配置解密参数
    const options = {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    };

    // Step 5: 解密
    const cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: ciphertext
    });
    const decrypted = CryptoJS.AES.decrypt(cipherParams, key, options);

    // Step 6: 返回 UTF-8 字符串
    return decrypted.toString(CryptoJS.enc.Utf8);
  } catch (err) {
    // throw new Error(`解密失败: ${err.message}`);
    throw new Error(`请稍后再试`);
  }
};


const getToken = () => {
  return localStorage.getItem('token') || '';
};

const getSystemParams = () => {
  let app_uuid = localStorage.getItem('app_uuid');
  if (!app_uuid) {
    app_uuid = randomUUID();
    localStorage.setItem('app_uuid', app_uuid);
  }

  let result = {
    sig_method: 'HMAC-SHA1',
    app_key: Settings.app_key,
    app_uuid: app_uuid,
    req_uuid: randomUUID(),
    timestamp: parseInt(new Date().getTime() / 1000),
  };

  return result;
};

const adaptor = (params) => {
  let sysParams = getSystemParams();
  // let newParams = { ...params, ...sysParams };
  let signature = buildSignature(sysParams);
  let data      = buildDataParams(params);
  return { ...sysParams, data: data, signature: signature };
};

export default class Api {
  
  static app_key = Settings.app_key;

  static get = async (uri, param) => {
    // console.log(param);
    let params = adaptor(param);
    let url = Settings.api_host + uri + '?' + new URLSearchParams(params).toString();
    

    let oHeaders = new Headers({
      'Content-Type': 'application/json',
      Accept: 'application/json',
      // "Access-Token": getToken(),
      Authorization: 'Bearer ' + getToken(),
    });

    let oRequest = new Request(url, {
      method: 'GET',
      mode: 'cors',
      headers: oHeaders,
    });

    return await fetch(oRequest).then(async (response) => {  
      let result  = await response.json();  // 等待解析完成  
      if (result.data == null) {
        return result;
      }
      const data  = JSON.parse(decryptDataParams(result.data));  
      // 检查是否为对象且包含list属性
      if (typeof data === 'object' && data !== null) {
        if ('list' in data) {
          result = {
            ...result,
            list: data.list,
            data: data,
          } 
        } else {
          result = {
            ...result,
            data: data,
          }
        }
        // 若 data 里包含 pagination 字段，将其追加到 result 上
        if ('pagination' in data) {
          result = {
            ...result,
            pagination: data.pagination
          }
        }
      }
      return result;  
    });  
    
  }; //end get

  static post = async (uri, param) => {
    let params = adaptor(param);
    // let url = Settings.api_host + uri;
    let url = Settings.api_host + uri + '?' + new URLSearchParams(params).toString();
    let oHeaders = new Headers({
      'Content-Type': 'application/x-www-form-urlencoded',
      // 'accept': 'application/json',
      // "Access-Token": getToken(),
      Authorization: 'Bearer ' + getToken(),
    });

    let oRequest = new Request(url, {
      method: 'POST',
      mode: 'cors',
      headers: oHeaders,
      body: qs.stringify({ data: params.data }),
    });

    return await fetch(oRequest).then(async (response) => {  
      const result = await response.json();  // 等待解析完成  
      if (result.data == null) {
        return result;
      }
      result.data = JSON.parse(decryptDataParams(result.data));  
      return result;  
    });
  }; //end post

  static formpost = async (uri, params) => {
    let sysParams = getSystemParams();
    let signature = buildSignature(sysParams);
    sysParams = { ...sysParams, signature: signature };

    let url = Settings.api_host + uri + '?' + new URLSearchParams(sysParams).toString();

    let data = buildDataParams(params);

    const formData = new URLSearchParams();
    formData.append('data', data);

    let oHeaders = new Headers({
      'Content-Type': 'application/x-www-form-urlencoded', //'multipart/form-data', // caution, if set, it will not include boundary=------
      Accept: 'application/x-www-form-urlencoded',
      Authorization: 'Bearer ' + getToken(),
    });

    let oRequest = new Request(url, {
      method: 'POST',
      mode: 'cors',
      headers: oHeaders,
      body: formData,
    });

    return await fetch(oRequest).then(async (response) => {  
      const result = await response.json();  // 等待解析完成  
      if (result.data == null) {
        return result;
      }
      result.data = JSON.parse(decryptDataParams(result.data));  
      return result;  
    }); 
  }; //end formpost

  static fileformpost = async (uri, key ,file, params) => {
    let sysParams = getSystemParams();
    let signature = buildSignature(sysParams);
    sysParams = { ...sysParams, signature: signature };

    let url = Settings.api_host + uri + '?' + new URLSearchParams(sysParams).toString();

    let data = buildDataParams(params);

    let formData = new FormData();
    formData.append('data', data);
    formData.append(key, file);

    let oHeaders = new Headers({
      // 'Content-Type': 'multipart/form-data',
      Authorization: 'Bearer ' + getToken(),
    });

    let oRequest = new Request(url, {
      method: 'POST',
      mode: 'cors',
      headers: oHeaders,
      body: formData,
    });

    return await fetch(oRequest).then(async (response) => {
      const result = await response.json();  // 等待解析完成  
      if (result.data == null) {
        return result;
      }
      result.data = JSON.parse(decryptDataParams(result.data));  
      return result; 
    });
  };

  static filesformpost = async (uri, fileParams, params) => {
    let sysParams = getSystemParams();
    let signature = buildSignature(sysParams);
    sysParams = { ...sysParams, signature: signature };

    let url = Settings.api_host + uri + '?' + new URLSearchParams(sysParams).toString();

    let data = buildDataParams(params);

    let formData = new FormData();
    for(const key in fileParams){
      // if(fileParams.hasOwnProperty(key)){
      //   formData.append(key, fileParams[key]);
      // }
      // 使用 Object.prototype.hasOwnProperty.call 检查属性
      if (Object.prototype.hasOwnProperty.call(fileParams, key)) {
        formData.append(key, fileParams[key]);
      }
    }
    formData.append('data', data);
    //formData.append(key, file);

    let oHeaders = new Headers({
      // 'Content-Type': 'multipart/form-data',
      Authorization: 'Bearer ' + getToken(),
    });

    let oRequest = new Request(url, {
      method: 'POST',
      mode: 'cors',
      headers: oHeaders,
      body: formData,
    });

    return await fetch(oRequest).then(async (response) => {  
      const result = await response.json();  // 等待解析完成  
      if (result.data == null) {
        return result;
      }
      result.data = JSON.parse(decryptDataParams(result.data));  
      return result;  
    });
  };

  static put = async (uri, params) => {
    let sysParams = getSystemParams();
    let signature = buildSignature(sysParams);
    sysParams = { ...sysParams, signature: signature };

    let url = Settings.api_host + uri + '?' + new URLSearchParams(sysParams).toString();

    let data = buildDataParams(params);

    let oHeaders = new Headers({
      'Content-Type': 'application/json',
      Accept: 'application/json',
      // "Access-Token": getToken(),
      Authorization: 'Bearer ' + getToken(),
    });

    let oRequest = new Request(url, {
      method: 'PUT',
      mode: 'cors',
      headers: oHeaders,
      body: JSON.stringify({ data: data }),
    });

    return await fetch(oRequest).then(async (response) => {
      let result  = await response.json();  // 等待解析完成  
      if (result.data == null) {
        return result;
      }
      const data  = JSON.parse(decryptDataParams(result.data));  
      // 检查是否为对象
      if (typeof data === 'object' && data !== null) {
        result = {
          ...result,
          data: data,
        }
      }
      return result;
    });
  };

  static delete = async (uri, param) => {
    let params = adaptor(param);
    let url = Settings.api_host + uri + '?' + new URLSearchParams(params).toString();
    let oHeaders = new Headers({
      'Content-Type': 'application/json',
      Accept: 'application/json',
      // "Access-Token": getToken(),
      Authorization: 'Bearer ' + getToken(),
    });

    let oRequest = new Request(url, {
      method: 'DELETE',
      mode: 'cors',
      headers: oHeaders,
      body: JSON.stringify(params),
    });

    return await fetch(oRequest)
      .then((response) => {
        if (response.ok) {
          if (response.status === 204) {
            const json = {};
            json.status = response.status;
            json.code = 0;
            return json;
          } else {
            return response.json();
          }
        } else {
          const json = {};
          json.status = response.status;
          json.code = response.status;
          json.msg = response.statusText
            ? response.statusText
            : response.status == 403
            ? '没有权限'
            : '';
          return json;
        }
      })
      .catch((error) => {
        console.log('error!!!!', error.status);
        if (error.status === 404) {
          // do something about 404
        }
      });
  }; // end delete

  static getUrl = (uri, param) => {
    // console.log(param);
    let params = adaptor(param);
    let url = 'https://www.shurenkeyan.com' + uri + '?' + new URLSearchParams(params).toString();
    
    return url;     
  };
}